<template>
  <div name="AnnouncementDetailComments" class="p-1">
    <h2 class="card-title">みんなの反応</h2>
    <ErrorMessage :status="reactionsApiStatus.status" :customMessage="reactionsApiStatus.customMessage" />
    <template v-if="reactionsApiStatus.status === 200">
      <b-container>
        <b-row>
          <b-col class="px-0">
            <div class="reaction_num">{{selectedAnnouncement.favorite_num}}</div>
            <div class="num-name">いいね</div>
            </b-col>
          <b-col class="px-0">
            <div class="reaction_num">{{selectedAnnouncement.reply_num}}</div>
            <div class="num-name">返信</div></b-col>
          <b-col class="px-0">
            <div class="reaction_num">{{selectedAnnouncement.open_num}}</div>
            <div class="num-name">既読</div></b-col>
        </b-row>
      </b-container>

      <div v-if="!listReactionDesc.length" class="bg-info text-white p-2 mt-2">
        表示できるコメントはありません
      </div>
      <div v-else class="reaction">
        <Comment
          v-for="(reaction, key) in listReactionDesc"
          :key="key"
          :reaction="reaction"
          @click-profile="handleClickProfile"
        />
      </div>
    </template>
  </div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue'
import Comment from '@/components/Announcement/AnnouncementDetailComment.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'AnnouncementDetailComments',

  components: {
    ErrorMessage,
    Comment
  },

  computed: {
    ...mapState({
      reactionsApiStatus: state => state.Announcement.listReactionApiStatus
    }),
    ...mapGetters('Announcement/', ['selectedAnnouncement', 'listReactionDesc'])
  },

  methods: {
    handleClickProfile: function (urlString) {
      this.$emit('click-profile', urlString)
    }
  },
  mounted() {
    this.$store.dispatch('Announcement/updateStudentUrls', this.listReactionDesc)
  },
  watch: {
    listReactionDesc() {
      this.$store.dispatch('Announcement/updateStudentUrls', this.listReactionDesc)
    }
  }
}
</script>

<style scoped>
.reaction_num {
  font-size: 28px;
  text-align: center;
  font-weight: bold;
}
.card-title {
  font-size: 24px;
  text-align: center;
}
.num-name {
  font-size: 12px;
  text-align: center;
  line-height: 14px;
}
.reaction {
  overflow-y: overlay;
  /* max-height: 100%; */
}
</style>
